// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"28c6b1e2","507":"b74b5e92","520":"fde6416e","737":"a6964e91","963":"94ac86ce"}[chunkId] + ".chunk.css";
};